import { Params, WithdrawToParentType } from 'app/dataTypes/cafeteria/compensation/withdraw/toParent'

import type { Request } from '../../../../index'


type ParamsApi = {
  withdraw_order_id: number
}

export const convertParams = ({
  withdrawID,
}: Params): [ParamsApi, null] => {
  return [{
    withdraw_order_id: parseInt(withdrawID, 10),
  }, null]
}

type WithdrawToParentApi = {
  result: 'success'
  order_data: {
    food_supplier_title: string
    food_supplier_head_fullname: string
    food_supplier_head_genitive: string
    student_fullname: string
    student_genitive: string
    student_payments_account: string
    parent_fullname: string
    parent_genitive: string
    school_title: string
    klass_title: string
    bank_title: string
    bik: string
    checking_account: string // р/с
    corr_account: string // к/с
    inn: string
    kpp: string
    parent_phone: string
    parent_address: string
  },
  value: number
}

export const convertResult = (data: WithdrawToParentApi): WithdrawToParentType => {
  const { value: availableWithdrawValue, order_data: orderData } = data
  const {
    student_fullname: studentFullname,
    parent_fullname: parentFullname,
    school_title: schoolTitle,
    klass_title: classTitle,
    bank_title: bankTitle,
    bik,
    checking_account: checkingAccount,
    corr_account: corrAccount,
    parent_phone: parentPhone,
    parent_address: parentAddress,
  } = orderData

  return {
    availableWithdrawValue,
    studentFullname,
    schoolTitle,
    classTitle,
    parentFullname,
    parentPhone,
    parentAddress,
    bankTitle,
    bik,
    checkingAccount,
    corrAccount,
  }
}

export const GET_COMPENSATION_WITHDRAW_ORDERS_SHOW: Request<Params, WithdrawToParentType, void> = [
  'cabinet/compensation/withdraw_orders/show',
  'get',
  ['data'],
]
